import { getUniqueList, updateListWithNewObject } from "../helpers/helpers";
import {
  LOAD_USERS,
  LOAD_USERS_FAIL,
  LOAD_USERS_SUCCESS,
  ADDING_USER,
  ADD_USER,
  ADD_USER_FAIL,
  ADD_USER_SUCCESS,
  SAVE_USER,
  SAVE_USER_FAIL,
  SAVE_USER_SUCCESS,
  TOGGLE_DEACTIVATE,
  TOGGLE_DEACTIVATE_FAIL,
  TOGGLE_DEACTIVATE_SUCCESS,
  VIEWING_USER,
  EDITING_USER,
  EDITING_USER_FORM,
  END_ACTION,
  VALIDATE_FORM_ERROR,
} from "./actionTypes";

import { startEditUser, saveUserRequest } from "./actionCreators";

const INITIAL_USER_FORM_DATA = {};

export const ADD_MODAL_DATA = {
  title: "Add User",
  submitText: "Add User",
  submitStyle: "success",
};

export const VIEW_MODAL_DATA = {
  title: "View User",
  submitText: "Edit User",
  submitStyle: "primary",
};

export const EDIT_MODAL_DATA = {
  title: "Edit User",
  submitText: "Save Changes",
  submitStyle: "success",
};

const initialState = {
  users: [],
  statuses: {},
  users_loaded: false,
  adding: false,
  viewing: false,
  editing: false,
  working: false,
  user_form_data: INITIAL_USER_FORM_DATA,
  modal_data: {},
  success: null,
  toggleDeactivateWorking: false,
};

export function reducer(state = initialState, action = {}) {
  let users = [];
  let newUser = {};
  let userFormData = {};

  switch (action.type) {
    case LOAD_USERS:
      return {
        ...state,
        users_loading: true,
      };

    case LOAD_USERS_SUCCESS:
      return {
        ...state,
        users_loading: false,
        users_loaded: true,
        users: action.result,
        error: null,
        statuses: getUniqueList(action.result, "status"),
      };
    case LOAD_USERS_FAIL:
      return {
        ...state,
        users_loading: false,
        users_loaded: false,
        users: null,
        error: action.error,
      };
    case ADDING_USER:
      return {
        ...state,
        adding: true,
        modal_data: ADD_MODAL_DATA,
        success: null,
      };

    case ADD_USER:
      return {
        ...state,
        working: true,
      };
    case ADD_USER_FAIL:
      return {
        ...state,
        working: false,
        error: action.error.message || action.error.error,
      };
    case ADD_USER_SUCCESS:
      users = Object.assign([], state.users);

      newUser = {
        ...state.user_form_data,
        user_id: action.result.id,
        status: "active",
      };

      users.unshift(newUser);

      return {
        ...state,
        error: null,
        adding: false,
        working: false,
        users,
        user_form_data: INITIAL_USER_FORM_DATA,
        success: `User **${state.user_form_data.user_username}** is added successfully.`,
      };
    case SAVE_USER:
      return {
        ...state,
        working: true,
      };
    case SAVE_USER_FAIL:
      return {
        ...state,
        working: false,
        error: action.error.message || action.error.error,
      };
    case SAVE_USER_SUCCESS: {
      users = [...state.users];
      const userIndex = users.findIndex(
        (user) => user.user_id === state.user_form_data.user_id
      );
      users.splice(userIndex, 1, state.user_form_data);

      return {
        ...state,
        error: null,
        viewing: false,
        editing: false,
        working: false,
        users,
        user_form_data: INITIAL_USER_FORM_DATA,
        success: `Changes to User **${state.user_form_data.user_username}** is successfully saved.`,
      };
    }
    case VIEWING_USER:
      return {
        ...state,
        viewing: true,
        modal_data: VIEW_MODAL_DATA,
        user_form_data: action.row,
        submit_func: startEditUser, // NOTE: why is there a function in the store?
        success: null,
      };

    case EDITING_USER:
      return {
        ...state,
        editing: true,
        modal_data: EDIT_MODAL_DATA,
        submit_func: saveUserRequest, // NOTE: why is there a function in the store?
      };
    case EDITING_USER_FORM:
      userFormData = {
        ...state.user_form_data,
        [action.input_id]: action.input_value,
      };

      return {
        ...state,
        user_form_data: userFormData,
      };
    case END_ACTION:
      return {
        ...state,
        editing: false,
        viewing: false,
        adding: false,
        working: false,
        user_form_data: INITIAL_USER_FORM_DATA,
        error: null,
      };
    case VALIDATE_FORM_ERROR:
      return {
        ...state,
        error: action.error.join("<br>"),
      };

    case TOGGLE_DEACTIVATE:
      return {
        ...state,
        toggleDeactivateWorking: true,
      };

    case TOGGLE_DEACTIVATE_SUCCESS: {
      const user = Object.assign({}, state.user_form_data);
      user.status = action.result.status;

      const resultingAction =
        action.result.status === "deleted" ? "deactivated" : "reactivated";

      const params = {
        list: Object.assign([], state.users),
        new_object: user,
        key: "user_id",
        value: state.user_form_data.user_id,
      };

      const updatedUsers = updateListWithNewObject(params);

      return {
        ...state,
        error: null,
        toggleDeactivateWorking: false,
        adding: false,
        viewing: false,
        editing: false,
        users: updatedUsers,
        toggleDeactivateUser: null,
        toggleDeactivateAction: null,
        statuses: getUniqueList(updatedUsers, "status"),
        success: `User **${action.result.username}** has been **${resultingAction}** successfully.`,
      };
    }
    case TOGGLE_DEACTIVATE_FAIL:
      return {
        ...state,
        error: action.error,
        toggleDeactivateWorking: false,
        toggleDeactivateUser: null,
        toggleDeactivateAction: null,
      };

    default:
      return state;
  }
}
